<template>
<div>
    <!-- modal -->
    <b-modal id="invoiceFormModal" centered size="xl" no-close-on-backdrop ref="invoiceFormModal" :title=" $t('invoice.info')" hide-footer>
        <validation-observer ref="simpleRules">
            <invoice-add-item-form ref="invoiceAddItemForm" :showInvoiceInfo="showInfo"></invoice-add-item-form>
            <invoice-add-dailywork-form ref="invoiceAddDailyworkForm" :showInvoiceInfo="showInfo"></invoice-add-dailywork-form>
            <invoice-update-item-form ref="invoiceUpdateItemForm" :showInvoiceInfo="showInfo"></invoice-update-item-form>
            <invoice-discount-form ref="invoiceDiscountForm" :showInvoiceInfo="showInfo"></invoice-discount-form>
            <create-ledes-form :getInvoiceList="getInvoiceList" ref="createLedesFormModal"></create-ledes-form>
            <reminder-form ref="reminderForm"></reminder-form>
            <div class="custom-search mb-1">
                <b-row>
                    <b-col class="col-3">
                        <label>{{ $t('invoice.debit_no') }} : {{ this.debitNo }}</label>
                    </b-col>
                    <b-col class="col-9  d-flex justify-content-end">
                        <b-button v-if="invoiceStatusId == 1" variant="outline-primary" size="sm" @click.prevent="addOrUpdate">
                            {{ $t('others.ok_title') }}
                        </b-button>
                        <b-button variant="outline-primary" class="ml-1" size="sm" v-b-tooltip.html :title="$t('invoice.show_proforma_invoice')" @click="downloadProformaInvoicePdf()">
                            <feather-icon icon="FileTextIcon" size="10" class="align-middle" />
                        </b-button>
                        <b-button v-if="this.invoiceUUID != null" variant="outline-primary" class="ml-1" size="sm" v-b-tooltip.html :title="$t('invoice.show_invoice')" @click="downloadInvoicePdf()">
                            <feather-icon icon="FileTextIcon" size="10" class="align-middle" />
                        </b-button>
                        <b-button variant="outline-dark" class="ml-1" size="sm" v-b-tooltip.html :title="$t('invoice.create_ledes')" @click="createLedes()">
                            <feather-icon icon="LayersIcon" size="10" class="align-middle" />
                        </b-button>
                        <b-button v-if="invoiceStatusId == 1" variant="outline-warning" class="ml-1" size="sm" v-b-tooltip.html :title="$t('invoice.send_approval')" @click="sendApproval()">
                            <feather-icon icon="CompassIcon" size="10" class="align-middle" />
                        </b-button>
                        <b-button variant="outline-primary" class="ml-1" size="sm" v-b-tooltip.html :title="$t('others.reminder')" @click="getReminderInfo()">
                            <feather-icon icon="BellIcon" size="10" class="align-middle" />
                        </b-button>
                    </b-col>
                </b-row>
            </div>

            <!-- Grid bölünmesi -->
            <b-form-group :disabled="invoiceStatusId > 1">
                <div class="row">
                    <!-- Sol kısım -->
                    <div class="col-lg-5">
                        <b-row>
                            <b-col class="col-lg-6">
                                <b-alert v-if="accountingNote != ''" variant="warning" style="cursor: pointer;" show v-b-modal.read-more-accounting-note-modal>
                                    <div class="alert-body demo-inline-spacing" v-b-tooltip.hover.top="this.accountingNote">
                                        {{ $t('invoice.accounting_note') }}
                                    </div>
                                </b-alert>
                                <b-modal id="read-more-accounting-note-modal" :title="$t('invoice.accounting_note')" hide-footer>
                                    <b-card-text> {{ this.accountingNote }}</b-card-text>
                                </b-modal>
                            </b-col>
                            <b-col class="col-lg-6">
                                <b-alert v-if="clientNote != ''" variant="warning" style="cursor: pointer;" show v-b-modal.read-more-client-note-modal>
                                    <div class="alert-body demo-inline-spacing" v-b-tooltip.hover.top="this.clientNote">
                                        {{ $t('invoice.client_note') }}
                                    </div>
                                </b-alert>
                                <b-modal id="read-more-client-note-modal" :title="$t('invoice.client_note')" hide-footer>
                                    <b-card-text> {{ this.clientNote }}</b-card-text>
                                </b-modal>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="col-lg-12">
                                <b-form>
                                    <label for="invoice-agent-input">{{ $t('invoice.agent') }}</label>
                                    <validation-provider :name="$t('invoice.agent')" #default="{ errors }" :rules="{ excluded: 0 }">
                                        <b-form-group :state="errors.length > 0 ? false : null">
                                            <v-select :disabled="roleId != 1  || departmentId == 2" size="sm" id="invoice-agent-input" v-model="agentSelect" :options="agentOption" @input="setClientId" class="w-100 custom-v-select agentInput" :get-option-label="$formatAgent" @search="onSearch">
                                            </v-select>
                                            <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                </b-form>
                            </b-col>
                        </b-row>
                        <b-row>
                            <!-- Sol kısım devam eden form alanları -->
                            <b-col class="col-lg-4">
                                <label for="invoice-date-input">{{ $t('invoice.date') }}</label>
                                <CustomDatePicker :datePickerValidateOption="0" v-model="proformaDate"></CustomDatePicker>
                            </b-col>
                            <b-col class="col-lg-4">
                                <label for="invoice-invoice-accounting-billing-status-input">{{ $t('invoice.billing_status') }}</label>
                                <b-form-select size="sm" v-model="billingStatusSelect" value-field="id" text-field="name" :options="billingStatusOption" />
                            </b-col>
                            <b-col class="col-lg-4">
                                <label for="invoice-employee-input">{{ $t('invoice.employee') }}</label>
                                <b-form-input disabled id="invoice-employee-input" :placeholder=" $t('invoice.employee')" size="sm" v-model="employee" />
                            </b-col>
                        </b-row>
                        <b-row>
                            <!-- Sol kısım devam eden form alanları -->
                            <b-col class="col-lg-12 mt-1">
                                <label for="invoice-header-input">{{ $t('invoice.title') }}</label>
                                <b-form-textarea id="invoice-header-input" :placeholder=" $t('invoice.title')" size="sm" rows="3" v-model="header" />
                            </b-col>
                        </b-row>
                        <b-row>
                            <!-- Sol kısım devam eden form alanları -->
                            <b-col class="col-lg-6 mt-1">
                                <label for="invoice-agent-reference-no-input">{{ $t('invoice.agent_reference_no') }}</label>
                                <b-form-input id="invoice-agent-reference-no-input" v-model="agentReferenceNo" size="sm" maxlength="100" />
                            </b-col>
                            <b-col class="col-lg-6 mt-1">
                                <label for="invoice-stock-reference-no-input">{{ $t('invoice.stock_ref_no') }}</label>
                                <b-form-input id="invoice-stock-reference-no-input" v-model="stockReferenceNo" size="sm" maxlength="100" />
                            </b-col>
                        </b-row>
                        <b-row>
                            <!-- Sol kısım devam eden form alanları -->
                            <b-col class="col-lg-4 mt-1">
                                <label for="invoice-invoice-proforma-type-input">{{ $t('invoice.proforma_type') }}</label>
                                <b-form-select disabled size="sm" v-model="proformaTypeSelect" value-field="id" text-field="name" :options="proformaTypeOption" />
                            </b-col>

                            <b-col class="col-lg-4 mt-1">
                                <label for="invoice-note-type-input">{{ $t('invoice.note_type') }}</label>
                                <b-form-select disabled size="sm" v-model="noteTypeSelect" value-field="id" text-field="code" :options="noteTypeOption" @change="noteTypeChange()" />
                            </b-col>
                            <b-col class="col-lg-4 mt-1">
                                <label for="invoice-financial-ref-input">{{ $t('invoice.financial_ref') }}</label>
                                <b-form-input disabled id="invoice-financial-ref-input" :placeholder=" $t('invoice.financial_ref')" size="sm" v-model="financialRef" />
                            </b-col>
                        </b-row>
                        <b-row>
                            <!-- Sol kısım devam eden form alanları -->
                            <b-col class="col-lg-12 mt-1">
                                <label for="invoice-invoice-note-input">{{ $t('invoice.note_type') }}</label>
                                <b-form-textarea disabled id="invoice-invoice-note-input" :placeholder=" $t('invoice.note_type')" size="sm" rows="4" v-model="invoiceNote" />
                            </b-col>
                        </b-row>
                    </div>
                    <!-- Sağ kısım -->
                    <div class="col-lg-7">
                        <b-row>
                            <!-- Sağ kısım devam eden form alanları -->
                            <b-col class="col-lg-12">
                                <b-row>
                                    <b-col class="col-3">
                                        <label class="mt-2" for="invoice-dailywork-input">{{ $t('invoice.item') }}</label>
                                    </b-col>
                                    <b-col class="col-9" style="text-align:right;">
                                        <b-button variant="link" @click="showAddDailyworkForm()">{{ $t('invoice.dailywork_add') }}</b-button>
                                        <b-button variant="link" @click="showAddItemForm()">{{ $t('invoice.add_item') }}</b-button>
                                        <b-button variant="link" @click="showDiscountForm()">{{ $t('invoice.apply_discount') }}</b-button>
                                    </b-col>
                                </b-row>
                                <draggable :disabled="invoiceStatusId > 1" v-model="invoiceDetailList" tag="ul" class="list-group list-group-flush cursor-move">
                                    <b-list-group-item v-for="(item, index) in invoiceDetailList" :key="index" tag="li">
                                        <b-row>
                                            <b-col class="col-1">
                                                <span>{{ item.record.recordNo }}</span>
                                            </b-col>
                                            <b-col class="col-6">
                                                <span> {{ item.name }} </span>
                                                <p v-if="item.ledesDetail.length > 5">
                                                    <br />
                                                    <span>{{ item.ledesDetail }}</span>
                                                </p>
                                            </b-col>
                                            <b-col class="col-2" style="text-align:right;">
                                                <span>{{ item.itemDefination}} </span>
                                                <span>{{ currency}} </span>
                                            </b-col>
                                            <b-col class="col-3">
                                                <b-button v-b-tooltip.html :title="$t('others.edit')" v-b-modal.modal-top variant="primary" class="btn-icon mb-1 ml-05" size="sm" @click="showUpdateItemForm(item.invoiceDetailId)">
                                                    <feather-icon icon="EditIcon" />
                                                </b-button>
                                                <b-button v-b-tooltip.html :title="$t('others.delete')" variant="warning" class="btn-icon mb-1 ml-05" size="sm" @click="deletedInvoiceDetail(item.invoiceDetailId)">
                                                    <feather-icon icon="XIcon" />
                                                </b-button>
                                                <b-button v-b-tooltip.html :title="$t('others.copy')" variant="success" class="btn-icon mb-1 ml-05" size="sm" @click="copyText(item.name)">
                                                    <feather-icon icon="CopyIcon" />
                                                </b-button>
                                            </b-col>
                                        </b-row>
                                    </b-list-group-item>
                                </draggable>
                                <b-list-group v-if="this.vatItem != null" style="border:none;">
                                    <b-row>
                                        <b-col class="col-2"></b-col>
                                        <b-col class="col-7" style="text-align:right;"> {{ $t('invoice.vat_amount') }} : </b-col>
                                        <b-col class="col-2" style="text-align:right;">
                                            <span style="font-weight: bold">
                                                {{ $formatMoney(this.vatItem.price) }}
                                            </span>
                                            <span style="font-weight: bold;">{{ currency}} </span>
                                        </b-col>
                                        <b-col class="col-1"> </b-col>
                                    </b-row>
                                </b-list-group>
                                <b-list-group style="border:none;">
                                    <b-row>
                                        <b-col class="col-2"></b-col>
                                        <b-col class="col-7" style="text-align:right;"> {{ $t('invoice.total') }} : </b-col>
                                        <b-col class="col-2" style="text-align:right;">
                                            <span style="color: red; font-weight: bold">
                                                {{ $formatMoney(this.total) }}
                                            </span>
                                            <span style="color: red; font-weight: bold;">{{ currency}} </span>
                                        </b-col>
                                        <b-col class="col-1"></b-col>
                                    </b-row>
                                </b-list-group>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </b-form-group>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getInvoiceList: {
            type: Function
        },
        getDailyworkList: {
            type: Function
        }
    },
    data() {
        return {
            invoiceData: null,
            invoice: null,
            id: 0,
            total: 0,
            debitNo: '',
            clientAccountingId: 0,
            agentSelect: 0,
            agentOption: [],
            vatItem: null,
            billingStatusSelect: 0,
            billingStatusOption: [],
            proformaDate: null,
            agentReferenceNo: '',
            stockReferenceNo: '',
            invoiceStatusId: 0,
            topic: '',
            noteTypeOption: [],
            noteTypeSelect: 0,
            proformaTypeOption: [],
            proformaTypeSelect: 0,
            header: '',
            currency: '',
            clientAccountingCode: '',
            clientName: '',
            invoiceNote: '',
            financialRef: '',
            isPaid: true,
            currencyId: 0,
            employeeDepartmentId : 0,
            columns: [{
                    label: this.$t('invoice.name'),
                    field: `recordNo`,
                },
                {
                    field: `name`,
                },
                {
                    field: `price`,
                }
            ],
            fields: [{
                    key: 'recordNo',
                    label: 'Record No',
                    sortable: true
                },
                {
                    key: 'name',
                    label: 'Name',
                    sortable: true
                },
                {
                    key: 'price',
                    label: 'Price',
                    sortable: true
                },
            ],
            invoiceDetailList: [],
            accountingNote: '',
            clientNote: '',
            clientNoteType: '',
            employee: '',
            roleId: 0,
            ledesTypeId: 0,
            invoiceUUID: null,
        }
    },
    methods: {
        invoiceNoteForAgent(clientAccountId) {
            this.clientNote = '';
            const data = {
                clientAccountingId: clientAccountId,
                noteTypeId: 2
            }
            const controller = {
                name: 'ClientNote',
                actionName: 'GetClientAccountingNoteWithClientNoteListByClientAccountingId'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                this.accountingNote = response.data.accountingNote
                response.data.clientNoteList.forEach(element => {
                    this.clientNote += element.note
                    this.clientNoteType = element.noteType
                })
            })
        },
        copyText(text) {
            navigator.clipboard.writeText(text).then(() => {
                this.$CopiedAlert()
            }).catch(err => {
                this.$WarningAlert()
            });
        },
        setClientId(event) {
            if (event != null) {
                this.clientAccountingId = event.clientAccountingId
            } else {
                this.clientAccountingId = null;
            }
        },
        onSearch(search, loading) {
            if (search.length) {
                loading(true);
                this.search(loading, search, this);
            }
        },
        search(loading, search, vm) {
            if (search.length > 2) {
                var accountingTypeId = 1

                if(this.debitNo && this.debitNo.toString().charAt(0) === '9')
                    accountingTypeId = 2

                const data = {
                    clientAccountingId: 0,
                    clientName: search,
                    clientAccountingTypeId: accountingTypeId,
                }
                const controller = {
                    name: 'ClientAccounting',
                    actionName: 'GetInvoiceClientAccountingByClientName'
                }
                const payload = {
                    data: data,
                    controller: controller
                }
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    this.agentOption = response.data.clientList
                    loading(false)
                })
            }
        },
        noteTypeChange() {
            if (this.noteTypeOption != null && this.noteTypeSelect > 0) {
                var note = this.noteTypeOption.find(p => p.id == this.noteTypeSelect)
                if (note != null)
                    this.invoiceNote = note.note
            }
        },
        createLedes() {
            this.$refs.createLedesFormModal.showInfo(this.id, this.clientAccountingId, this.ledesTypeId)
        },
        sendApproval() {
            this.$PrivateConfirm(this.$t("invoice.confirm_title"), this.$t("invoice.confirm_message"), "warning", this.$t("invoice.confirm_button_text"), this.$t("invoice.cancel_button_text")).then(result => {
                if (result.value) {
                    const data = {
                        id: this.id,
                        invoiceStatusId: 2
                    }
                    const controller = {
                        name: 'Invoice',
                        actionName: 'ChangeInvoiceStatus'
                    }
                    const payload = {
                        data: data,
                        controller: controller
                    }
                    this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            if (this.getInvoiceList != null) {
                                this.getInvoiceList()
                            }
                            if (this.getDailyworkList != null) {
                                this.getDailyworkList()
                            }
                            this.showInfo(this.id)
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        },
        async getReminderInfo() {
            this.$refs.reminderForm.showInfo(0, this.id, 20)
        },
        showInfo(id) {
            this.employeeDepartmentId = localStorage.getItem('DepartmentId')
            this.roleId = localStorage.getItem('RoleId')
            this.$refs['invoiceFormModal'].show()
            this.invoiceDetailList = []

            this.accountingNote = ''
            this.clientNote = ''

            this.id = id
            const data = {
                id: this.id
            }
            const controller = {
                name: 'Invoice'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.invoiceData = response.data
                    this.total = response.data.invoice.total
                    this.invoiceStatusId = response.data.invoice.invoiceStatusId
                    this.invoiceUUID = response.data.invoice.invoiceUUID
                    this.debitNo = response.data.invoice.debitNo
                    this.proformaDate = response.data.invoice.proformaDate
                    this.financialRef = response.data.invoice.financialRef
                    this.agentReferenceNo = response.data.invoice.agentReferenceNo
                    this.stockReferenceNo = response.data.invoice.stockReferenceNo
                    this.header = response.data.invoice.header
                    this.noteTypeSelect = response.data.invoice.noteToBeOnInvoiceId
                    this.noteTypeOption = response.data.noteToBeOnInvoiceList
                    this.noteTypeOption.splice(0, 0, this.$nullSelected('code'))
                    this.noteTypeChange()
                    this.billingStatusSelect = response.data.invoice.billingStatusId
                    this.billingStatusOption = response.data.billingStatusList
                    this.billingStatusOption.splice(0, 0, this.$nullSelected())
                    this.isPaid = response.data.invoice.isPaid
                    this.proformaTypeSelect = response.data.invoice.proformaTypeId
                    this.proformaTypeOption = response.data.proformaTypeList

                    this.clientName = response.data.invoice.client
                    this.currency = response.data.invoice.currencyCode
                    this.currencyId = response.data.invoice.currencyId
                    this.employee = response.data.invoice.employee
                    if (response.data.invoiceDetailList != null) {
                        this.invoiceDetailList = response.data.invoiceDetailList
                    }
                    this.vatItem = response.data.vatItem
                    //STOCK-1960
                    this.ledesTypeId = response.data.invoice.ledesTypeId
                    this.clientAccountingId = response.data.invoice.clientAccountingId
                    if (response.data.invoice.clientAccountingId > 0) {
                        const clientAccountingData = {
                            clientAccountingId: response.data.invoice.clientAccountingId
                        }
                        const clientAccountingController = {
                            name: 'ClientAccounting',
                            actionName: 'GetClientAccountingByClientName'
                        }
                        const clientAccountingPayload = {
                            data: clientAccountingData,
                            controller: clientAccountingController
                        }
                        this.$store.dispatch('moduleAuth/customService', clientAccountingPayload).then((clientAccountingResponse) => {
                            this.agentOption = clientAccountingResponse.data.clientList
                            this.agentSelect = clientAccountingResponse.data.clientList[0]
                            this.clientAccountingId = clientAccountingResponse.data.clientList[0].clientAccountingId
                        })
                    } else {
                        this.agentOption = []
                        this.agentSelect = 0;
                    }
                    this.invoiceNoteForAgent(this.clientAccountingId)
                } else {
                    this.$bvModal.hide('invoiceFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        showAddDailyworkForm() {
            this.$refs.invoiceAddDailyworkForm.showInfo(this.id, this.clientAccountingId)
        },
        showInfoFromDailyWorkList(dailyWorkList) {
            this.accountingNote = ''
            this.clientNote = ''

            this.id = 0
            const data = {
                employeeId: localStorage.getItem('EmployeeId'),
                invoiceDetailList: dailyWorkList
            }
            const controller = {
                name: 'Invoice',
                actionName: 'GetInfoFromDailyWorkList'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    if (this.getInvoiceList != null) {
                        this.getInvoiceList()
                    }
                    if (this.getDailyworkList != null) {
                        this.getDailyworkList()
                    }
                    this.showInfo(response.data.invoiceId)
                    this.$root.$emit('invoice:saved')
                } else {
                    this.$bvModal.hide('invoiceFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        addOrUpdate() {
            if (this.invoiceDetailList.length == 0) {
                this.$ErrorSaveAlert()
                return
            }

            const data = {
                invoiceDto: {
                    id: this.id,
                    proformaDate: this.proformaDate,
                    employeeId: localStorage.getItem('EmployeeId'),
                    clientAccountingId: this.clientAccountingId,
                    header: this.header,
                    agentReferenceNo: this.agentReferenceNo,
                    stockReferenceNo: this.stockReferenceNo,
                    noteToBeOnInvoiceId: this.noteTypeSelect,
                    billingStatusId: this.billingStatusSelect,
                    proformaTypeId: this.proformaTypeSelect,
                    financialRef: this.financialRef,
                    currencyId: this.currencyId
                },
                invoiceDetailList: this.invoiceDetailList,
            }
            const controller = {
                name: 'Invoice'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.id = response.data.invoiceId
                            this.debitNo = response.data.debitNo
                            this.showInfo(response.data.invoiceId)
                            //this.$bvModal.hide('invoiceFormModal')
                            if (this.getInvoiceList != null) {
                                this.getInvoiceList()
                            }
                            if (this.getDailyworkList != null) {
                                this.getDailyworkList()
                            }
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        },
        async showDiscountForm() {
            this.$refs.invoiceDiscountForm.showInfo(this.id, this.currencyId, this.invoiceData.invoiceDetailList.length)
        },
        async showAddItemForm() {
            this.$refs.invoiceAddItemForm.showInfo(this.id, this.currencyId, this.invoiceData.invoiceDetailList.length)
        },
        async showUpdateItemForm(detailId) {
            this.$refs.invoiceUpdateItemForm.showInfo(detailId, this.id)
        },
        async downloadProformaInvoicePdf() {
            const data = {
                InvoiceId: this.id,
            }
            const controller = {
                name: 'Invoice',
                actionName: 'DownloadProforma'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile(response.data.document.name, response.data.base64, response.data.document.type)
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        async downloadInvoicePdf() {
            const data = {
                uuid: this.invoiceUUID,
            }
            const controller = {
                name: 'NesEArchiveFatura',
                actionName: 'DownloadEArchiveInvoiceAsPdf'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile(this.invoiceUUID, response.data.base64, "pdf")
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        async deletedInvoiceDetail(id) {
            const data = {
                id: id
            }
            const controller = {
                name: 'InvoiceDetail'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$DeleteConfirm().then(result => {
                if (result.value) {
                    this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$DeleteAlert()
                            this.showInfo(this.id)
                        }

                        if (this.getInvoiceList != null) {
                            this.getInvoiceList()
                        }
                        if (this.getDailyworkList != null) {
                            this.getDailyworkList()
                        }

                    })
                }
            })
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}

[dir] .vs__selected-options {
    padding: 0 2px;
    font-size: 0.9em;
}

.datepickerStyle {
    max-height: 2.2em;
    font-family: fangsong;
}

.agentInput {
    max-width: 87em !important;
    width: 86em !important;
}

.custom-v-select .vs__selected,
.custom-v-select .vs__dropdown-option {
    white-space: pre-wrap !important;
}

.read-more-button {
    height: 3em;
    width: 3em;
}
</style>
